if (!customElements.get('lnl-products-carousel')) {
  class LnlProductsCarousel extends HTMLElement {
    connectedCallback() {
      this.swiperEl = this.querySelector('.swiper');
      this.initSwiper();
    }

    disconnectedCallback() {
      clearTimeout(this.swiperRetry);
      if (this.swiperEl && this.swiperEl.swiper) this.swiperEl.swiper.destroy(true, true);
    }

    initSwiper() {
      if (!this.swiperEl || this.swiperEl.swiper) return;

      if (typeof Swiper === 'undefined') {
        this.swiperRetry = setTimeout(() => this.initSwiper(), 100);
        return;
      }

      const data = this.swiperEl.dataset;
      const slidesDesktop = parseInt(data.slidesDesktop) || 4;
      const gapDesktop = parseInt(data.gapDesktop) || 20;
      const gapMobile = parseInt(data.gapMobile) || 10;
      const autoplay = data.autoplay === 'true';
      const autoplaySpeed = parseInt(data.autoplaySpeed) || 3000;

      new Swiper(this.swiperEl, {
        slidesPerView: 1.3,
        spaceBetween: gapMobile,
        grabCursor: true,
        watchSlidesProgress: true,
        loop: false,

        autoplay: autoplay
          ? {
              delay: autoplaySpeed,
              disableOnInteraction: false,
            }
          : false,

        breakpoints: {
          576: {
            slidesPerView: 2.3,
            spaceBetween: gapMobile,
          },
          992: {
            slidesPerView: slidesDesktop,
            spaceBetween: gapDesktop,
          },
        },
      });
    }
  }

  customElements.define('lnl-products-carousel', LnlProductsCarousel);
}
